module.exports = __webpack_public_path__ + "img/5.d9279a5d.jpg";